import ResponseEnterMetadataComponent from '../../components/CreateResponse/components/enter-metadata.component';
import UserCard from '../../components/Profile/user-card';
import RequestCard from '../../components/CreateRequest/components/request-card.component';
import { useEffect } from 'react';
import { useState } from 'react';
import { fetchRequestDetail } from '../../apis/request.api';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const EQUITY_PERCENTAGE_TOOLTIP =
  "If your response is approved by the writer, you will share a percentage of the article's equity. This means you’ll be credited as a contributors and share in its success. You can propose a different percentage in the form below.";

const DetailRequest = () => {
  const [request, setRequest] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const match = window.location.href.match(/\/request\/([^\/]+)\//);
        const requestId = match ? match[1] : null;

        const requestRes = await fetchRequestDetail(requestId);
        if (requestRes) setRequest(requestRes);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  // Generate SEO metadata for request details page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['request/detail'].name,
    dynamicPages['request/detail'].url,
    dynamicPages['request/detail'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      <div className={'max-w-[636px] mx-auto flex flex-col items-center mb-[150px] px-4'}>
        <div className=" pt-5 md:pt-8 pb-6 w-full text-left z-10">
          <h1 className="text-2xl md:text-[28px] font-[800] mb-8">Content Request Details</h1>
          <UserCard user={request?.user} />
          <div className="my-[8px] h-[2px] bg-04-anti-flash-white"></div>
          <RequestCard request={request} tooltips={EQUITY_PERCENTAGE_TOOLTIP} />
        </div>
        <div className="text-left w-full text-[18px] font-[600] mb-[24px]">
          Contribute to the article by filling out the form below:
        </div>
        <div className="w-full">
          <ResponseEnterMetadataComponent request={request} />
        </div>
      </div>
    </div>
  );
};

export default DetailRequest;
